import { useState } from 'react';
import { apiClient } from '../lib/api-client';

interface UseDeleteJobResult {
  deleteJob: (jobId: string) => Promise<void>;
  isLoading: boolean;
  error: Error | null;
}

export function useDeleteJob(): UseDeleteJobResult {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const deleteJob = async (jobId: string): Promise<void> => {
    try {
      setIsLoading(true);
      setError(null);
      
      await apiClient.delete(`/jobs/${jobId}`);
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to delete job');
      setError(error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    deleteJob,
    isLoading,
    error,
  };
}
